import { render, staticRenderFns } from "./JobAssignmentOrdersTable.vue?vue&type=template&id=16bb53d4&"
import script from "./JobAssignmentOrdersTable.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports